import(/* webpackMode: "eager", webpackExports: ["TeamsListSkeleton"] */ "/var/www/schedly/calcom/apps/web/app/(use-page-wrapper)/(main-nav)/teams/skeleton.tsx");
